export default "__VITE_ASSET__Bqv5pjTo__"